import React from 'react';
import PropTypes from 'prop-types';
import { AlertCircleIcon, LockKeyhole } from 'lucide-react';
import { Alert, AlertTitle } from 'components/ui/alert';
import { Button } from 'components/ui/button';
import Locales from 'locales';
import { useIsMutating } from '@tanstack/react-query';

const PlatformUnlocked = ({ handleOpenConfirmationModal }) => {
  const isMutating = useIsMutating() > 0;

  return (
    <article className="space-y-4 p-6 bg-white rounded-xl shadow-md">
      <Alert variant="default" className="bg-blue-100">
        <AlertCircleIcon className="size-[16px]" />
        <AlertTitle>{Locales.preferences.settings.alert.unlock_platform}</AlertTitle>
      </Alert>

      <p>
        {Locales.formatString(Locales.preferences.settings.first_description_lock, {
          readOnly: <strong>{Locales.preferences.settings.read_only}</strong>,
        })}
      </p>
      <p>{Locales.preferences.settings.second_description_lock}</p>

      <Button variant="destructive" onClick={handleOpenConfirmationModal} disabled={isMutating}>
        <LockKeyhole />
        {Locales.preferences.settings.button.lock_platform}
      </Button>
    </article>
  );
};

PlatformUnlocked.propTypes = {
  handleOpenConfirmationModal: PropTypes.func.isRequired,
};

export default PlatformUnlocked;
